import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ChartingSidebarTab = "chart" | "profile";

interface ChartingSidebarTabStore {
  // The patient sidebar in Notes opens on whichever tab was used last.
  tab: ChartingSidebarTab;
  setTab: (tab: ChartingSidebarTab) => void;
}

export const useChartingSidebarTabStore = create<ChartingSidebarTabStore>()(
  persist(
    (set) => ({
      tab: "chart",
      setTab: (tab) => set({ tab }),
    }),
    {
      name: "charting-sidebar-tab-store",
      partialize: (state) => ({ tab: state.tab }),
    },
  ),
);
